export default __webpack_public_path__ + "static/media/icon-garage-opener.95fc5ae6.svg";